/* Shared signup consent, first-visit attribution and bounded requests. No Meta events: Ops validates email first. */
(function () {
  'use strict';
  if (window.EBSaleSignupTracking) return;
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id'];
  var ATTRIBUTION_KEYS = UTM_KEYS.concat(['campaign_id', 'adset_id', 'ad_id']);
  var ATTRIBUTION_TTL = 30 * 24 * 60 * 60 * 1000;
  var storagePrefix = 'eb_sale_signup_attribution:';
  // This marker identifies only this document lifetime. It lets a consent
  // upgrade enrich the original visit without splicing a later click into it.
  var pageVisitId = String(Date.now()) + ':' + String(Math.random()).slice(2);

  // Shopify resolves regional defaults and any recorded privacy choices. A missing
  // or failed API must never silently grant permission to send an advertising event.
  function permissions() {
    var result = { analytics: false, advertising: false, known: false };
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (!privacy) return result;
      result.known = true;
      result.analytics = typeof privacy.analyticsProcessingAllowed === 'function' && privacy.analyticsProcessingAllowed() === true;
      result.advertising = typeof privacy.marketingAllowed === 'function' && privacy.marketingAllowed() === true &&
        typeof privacy.saleOfDataAllowed === 'function' && privacy.saleOfDataAllowed() === true;
    } catch (e) { /* fail closed */ }
    return result;
  }

  var privacyReady = new Promise(function (resolve) {
    if (window.Shopify && window.Shopify.customerPrivacy) { resolve(); return; }
    var done = false;
    function finish() {
      if (done) return;
      done = true;
      resolve();
    }
    var timer = window.setTimeout(finish, 2500);
    try {
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], function () {
          window.clearTimeout(timer);
          finish();
        });
      } else {
        window.clearTimeout(timer);
        finish();
      }
    } catch (e) {
      window.clearTimeout(timer);
      finish();
    }
  });

  function safeUrl(value, includeAttribution, advertising) {
    try {
      var url = new URL(value, window.location.origin);
      if (url.protocol !== 'https:' && url.protocol !== 'http:') return null;
      var clean = new URL(url.origin + url.pathname);
      if (includeAttribution) {
        ATTRIBUTION_KEYS.concat(advertising ? ['fbclid'] : []).forEach(function (key) {
          var v = url.searchParams.get(key);
          if (v) clean.searchParams.set(key, String(v).slice(0, key === 'fbclid' ? 1024 : 200));
        });
      }
      return clean.href;
    } catch (e) { return null; }
  }

  function cookie(name) {
    try {
      var prefix = name + '=';
      var parts = document.cookie.split(';');
      for (var i = 0; i < parts.length; i++) {
        var value = parts[i].trim();
        if (value.indexOf(prefix) === 0) return decodeURIComponent(value.slice(prefix.length));
      }
    } catch (e) { /* unavailable */ }
    return null;
  }

  function readStorage(key) {
    try { return JSON.parse(window.localStorage.getItem(key) || 'null'); }
    catch (e) { return null; }
  }

  function removeStorage(key) {
    try { window.localStorage.removeItem(key); } catch (e) { /* unavailable */ }
  }

  function currentAttribution(consent) {
    var out = {};
    try {
      var params = new URLSearchParams(window.location.search);
      ATTRIBUTION_KEYS.forEach(function (key) {
        var value = params.get(key);
        if (value) out[key] = String(value).slice(0, 200);
      });
      if (consent.advertising && params.get('fbclid')) out.fbclid = params.get('fbclid').slice(0, 1024);
    } catch (e) { /* leave attribution empty */ }
    // Campaign IDs are the stable UTM values configured on this campaign.
    if (!out.campaign_id && /^\d+$/.test(out.utm_campaign || '')) out.campaign_id = out.utm_campaign;
    if (!out.campaign_id && /^\d+$/.test(out.utm_id || '')) out.campaign_id = out.utm_id;
    if (!out.adset_id && /^\d+$/.test(out.utm_term || '')) out.adset_id = out.utm_term;
    if (!out.ad_id && /^\d+$/.test(out.utm_content || '')) out.ad_id = out.utm_content;
    out.landing_url = safeUrl(window.location.href, true, consent.advertising);
    out.referrer = document.referrer ? safeUrl(document.referrer, false, false) : null;
    out.saved_at = Date.now();
    out.visit_id = pageVisitId;
    return out;
  }

  function hasCampaign(value) {
    return ATTRIBUTION_KEYS.some(function (key) { return !!value[key]; }) || !!value.fbclid;
  }

  function attribution(saleKey, consent) {
    var key = storagePrefix + (saleKey || 'current');
    if (!consent.analytics && !consent.advertising) {
      // Not knowing yet (a slow privacy API) is not a refusal, so it keeps an
      // earlier visit's snapshot. Either way nothing is stored, but this page's own
      // campaign parameters still go: they aren't personal data, and Ops records them.
      if (consent.known !== false) removeStorage(key);
      var current = currentAttribution(consent);
      var bare = { landing_url: safeUrl(window.location.href, false, false) };
      ATTRIBUTION_KEYS.forEach(function (name) { if (current[name]) bare[name] = current[name]; });
      return bare;
    }
    var now = Date.now();
    var fresh = currentAttribution(consent);
    var first = readStorage(key);
    if (!first || typeof first.saved_at !== 'number' || now - first.saved_at > ATTRIBUTION_TTL || first.saved_at > now ||
        (!hasCampaign(first) && hasCampaign(fresh))) first = fresh;
    // The first snapshot may have been taken with analytics permission only.
    // If advertising is allowed later on that same document and exact campaign
    // URL, capture its now-permitted click ID without changing first-touch data.
    // A new document or a different campaign/ad URL must never enrich that visit.
    if (consent.advertising && !first.fbclid && fresh.fbclid && first.visit_id === pageVisitId &&
        ATTRIBUTION_KEYS.every(function (name) { return (first[name] || '') === (fresh[name] || ''); }) &&
        safeUrl(first.landing_url, true, false) === safeUrl(fresh.landing_url, true, false)) {
      first.fbclid = fresh.fbclid;
    }
    // Consent can change between visits. Strip ad identifiers before saving or
    // transmitting a snapshot when the shopper no longer permits advertising.
    if (!consent.advertising) {
      delete first.fbclid;
      first.landing_url = safeUrl(first.landing_url, true, false);
    }
    try { window.localStorage.setItem(key, JSON.stringify(first)); } catch (e) { /* private mode */ }
    var out = {};
    ATTRIBUTION_KEYS.concat(['landing_url', 'referrer', 'fbclid']).forEach(function (name) {
      if (first[name]) out[name] = first[name];
    });
    if (consent.advertising) {
      out.fbp = cookie('_fbp');
      out.fbc = cookie('_fbc');
      if (!out.fbc && out.fbclid) out.fbc = 'fb.1.' + first.saved_at + '.' + out.fbclid;
    }
    return out;
  }

  function post(endpoint, payload) {
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = controller && window.setTimeout(function () { controller.abort(); }, 15000);
    return fetch(endpoint, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload), signal: controller ? controller.signal : undefined
    }).then(function (response) {
      return response.json().catch(function (error) {
        if (error.name === 'AbortError') throw error;
        return null;
      }).then(function (data) { return { response: response, data: data }; });
    }).finally(function () { if (timer) window.clearTimeout(timer); });
  }

  window.EBSaleSignupTracking = {
    ready: privacyReady, permissions: permissions, attribution: attribution, safeUrl: safeUrl, post: post
  };
})();
